export const COMMUNICATION_GRADIENT_COLORS = {
  start: '#0952b7',
  mid: '#437bc7',
  end: '#1756ac',
} as const

export const COMMUNICATION_CARD_BACKGROUND =
  'linear-gradient(225deg, #0952b7 0%, #437bc7 50%, #1756ac 100%)'
